import { Controller } from "@hotwired/stimulus"

// Measurement beacon: tells the server the referral link was copied so the
// nudge retires itself and the copy shows up in admin stats. The actual
// clipboard write is handled by the clipboard controller on the same element.
export default class extends Controller {
  static values = { url: String }

  copied() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, { method: "POST", headers: { "X-CSRF-Token": token } })
  }
}
